import { render, staticRenderFns } from "./activeList.vue?vue&type=template&id=bc7c2012&scoped=true&"
import script from "./activeList.vue?vue&type=script&lang=js&"
export * from "./activeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7c2012",
  null
  
)

export default component.exports